import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import { messages } from '@/utils/languages';
import router from './views/router.js';
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const i18n = createI18n({
    locale: 'es',
    fallbackLocale: 'en',
    messages
  })

const vuetify = createVuetify({
  components,
  directives,
})

import '@/style.css'

const app = createApp(App)
app.use(i18n)
app.use(vuetify)
app.use(router);
app.mount('#app')
